import React, { useState } from "react";
import { Card, DataTable, Button, Text, InlineStack } from "@shopify/polaris";
import ConfirmationModal from "../Common/ConfirmationModal";
import { CancelOrder } from "../../services/order";
import { PAGE_SIZE } from "../../constants/common-constants";

const OrderTable = ({ orders, currentPage, setCurrentPage, fetchData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleCancelClick = (order) => {
    setSelectedOrder(order);
    setModalOpen(true);
  };

  const handleCancelConfirm = async () => {
    await CancelOrder(selectedOrder._id);
    await fetchData();
    setModalOpen(false);
  };

  function capitalizeEachWord(str) {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const rows = orders.map((order) => [
    `${order.name ?? "-"} `,
    `₹${order.amount}`,

    capitalizeEachWord(order.paymentStatus),
    order.createdAt ? new Date(order.createdAt).toLocaleString() : "-",
    capitalizeEachWord(order.user.name),

    capitalizeEachWord(order.user.address.state),
    order.user.email,

    <InlineStack gap={100}>
      {order.orderStatusUrl ? (
        <Button url={order.orderStatusUrl} size="slim">
          Details
        </Button>
      ) : (
        <Button disabled={true} url={order.orderStatusUrl} size="slim">
          Details
        </Button>
      )}
      {order.trackingUrl ? (
        <Button url={order.trackingUrl} size="slim">
          Track
        </Button>
      ) : (
        <Button disabled={true} url={order.orderStatusUrl} size="slim">
          Track
        </Button>
      )}
      <Button
        disabled={order.status !== "pending"}
        size="slim"
        onClick={() => handleCancelClick(order)}
      >
        Cancel
      </Button>
    </InlineStack>,
  ]);

  return (
    <Card>
      <DataTable
        hideScrollIndicator
        columnContentTypes={[
          // "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
        ]}
        headings={[
          // "Status",
          <Text variant="headingSm"> Name</Text>,
          <Text variant="headingSm"> Amount</Text>,

          // <Text variant="headingSm"> Currency</Text>,
          // <Text variant="headingSm"> Status</Text>,
          // <Text variant="headingSm"> Tracking</Text>,
          <Text variant="headingSm"> Payment</Text>,
          <Text variant="headingSm"> Ordered on</Text>,
          <Text variant="headingSm"> Name</Text>,
          <Text variant="headingSm"> City</Text>,
          <Text variant="headingSm"> Email</Text>,
          <Text variant="headingSm"> Actions </Text>,
        ]}
        rows={rows}
        pagination={{
          hasNext: orders.length >= PAGE_SIZE,
          onNext: () => {
            setCurrentPage(currentPage + 1);
          },
          onPrevious: () => {
            if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          },
          hasPrevious: currentPage > 1,
        }}
      />
      {modalOpen && selectedOrder && (
        <ConfirmationModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onConfirm={handleCancelConfirm}
          title="Confirm Deletion"
          message={`Are you sure you want to cancel the order ${selectedOrder.orderShopifyId} This action cannot be undone.`}
        />
      )}
    </Card>
  );
};

export default OrderTable;
